/**
 * PageList permet de stocker de manière optimisée l'équivalence entre un numéro de page et un label de page.
 * ["A","B","1","2","3","D1"] <=> "1:A;2:B;3-5:-2;6:D1"
 * A lire : la page 1 s'appelle "A", les pages de 3 à 5 sont des nombres qui se suivent et il faut ajouter -2 pour avoir le label correspondant
 * Avec des gros documents le gain est plus flagrant ;)
 * Les cas possibles de numérotation non continues sont :
 * * en italie la numérotation commence à 0
 * * un feuillet intégré en fin de documents
 * * chez dalloz, certaines publications on une numérotation qui se suit d'un numéro à l'autre
 */
var PageList = {
    /**
     * transforme un tableau de labels de page en un format compressé
     * @param  {Array} page_label_array tableau de labels de pages, par exemple : ["A","B","1","2","3","D1"]
     */
    compress:function(page_label_array){
        var compressed=[], page_value, previous_value=-10000, start_page_index=0, end_page_index=0, diff_index=0;
        page_label_array.forEach(function(page_label,page_index){
            page_value=parseInt(page_label, 10);    // 12

            if(isNaN(page_value)){
                // c'est un libellé A,III, etc
                // si il y avait une série en cours, on la finie
                if(start_page_index){
                    compressed.push(start_page_index+"-"+end_page_index+":"+diff_index);
                    start_page_index=0; end_page_index=0; diff_index=0; previous_value=-10000;
                }
                compressed.push((page_index+1)+":"+page_label);
            }
            else{
                // c'est un nombre, est-ce qu'il suit le nombre précédent ?
                if(previous_value+1==page_value){
                    // série en cours
                    end_page_index=page_index+1;
                }
                else{
                    // série terminée, on ferme la série courante si elle existe et on en commence une autre
                    if(start_page_index){
                        compressed.push(start_page_index+"-"+end_page_index+":"+diff_index);
                    }


                    diff_index=page_value-page_index-1;
                    start_page_index=page_index+1;
                    end_page_index=start_page_index;
                }
                previous_value=page_value;
            }
        });

        // dernière série si elle existe
        if(start_page_index){
            compressed.push(start_page_index+"-"+end_page_index+":"+diff_index);
        }

        return compressed.join(";");
    },

    /**
     * transforme une string qui définit l'équivalence page index/label compressée en un tableau de labels de pages
     * la page 1 est en 0
     * @param  {String} compressed_string "1:A;2:B;3-5:-2;6:D1"
     * @return {Array}                   [description]
     */
    uncompress:function(compressed_string) {
        var compressed_array=compressed_string.split(";");
        var page_labels=[];
        compressed_array.forEach(function(equivalence){
           var equivalence_splitted=equivalence.split(":");
           if(equivalence_splitted.length==2){
               var page_index=equivalence_splitted[0];
               var page_index_split=page_index.split("-");
               var page_label=equivalence_splitted[1];
               if(page_index_split.length==1){
                   //6:D1
                  page_labels[parseInt(page_index_split[0])-1]=page_label;
               }
               else if(page_index_split.length==2){
                   //3-5:-2
                   var start=parseInt(page_index_split[0]);
                   var end=parseInt(page_index_split[1]);
                   if(start<=end){
                       var page_label_int=parseInt(page_label);
                       for(var i=start;i<=end;i++){
                           page_labels[i-1]=String(i+page_label_int);
                       }
                   }
               }
           }
        });
        return page_labels;
    }
};

module.exports = PageList;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@immanens-com/pv5js/reader/lib/page-list.js
// module id = 40
// module chunks = 0